export const DEFAULT = 'DEFAULT';
export const REPORT_TEMPLATE = 'REPORT_TEMPLATE';
// These TestIds are referenced externally by ATs in other apps, so change with caution
export let SingleReportViewerTabTestIds;
(function (SingleReportViewerTabTestIds) {
  SingleReportViewerTabTestIds["Filters"] = "srv-filters-tab";
  SingleReportViewerTabTestIds["About"] = "srv-about-tab";
  SingleReportViewerTabTestIds["Edit"] = "srv-edit-tab";
  SingleReportViewerTabTestIds["DataQuality"] = "srv-data-quality-tab";
})(SingleReportViewerTabTestIds || (SingleReportViewerTabTestIds = {}));